enum StickerType {
  Static = 1,
  Lottie = 2,
  WebM = 3
}

export default StickerType;
